import api from '@/lib/api/axios'
import type { Layer, ListParams, PaginatedResponse } from '@/lib/api/types'

export const layersApi = {
    list: (params?: ListParams) =>
        api.get<PaginatedResponse<Layer>>('/api/layers', { params }),

    get: (id: number) =>
        api.get<Layer>(`/api/layers/${id}`),

    add: (data: { description?: string }) =>
        api.post<Layer>('/api/layers', data),

    insert: (data: { insertAfterLayerID?: number | null; description?: string }) =>
        api.post<Layer>('/api/layers/insert', data),

    update: (id: number, data: Partial<Omit<Layer, 'id' | 'createdAt' | 'updatedAt'>>) =>
        api.put<Layer>(`/api/layers/${id}`, data),

    delete: (id: number) =>
        api.delete(`/api/layers/${id}`),
}

